(function () {
  'use strict';

  var desktop = window.matchMedia('(min-width: 769px)');

  function syncPriceRanges() {
    if (!desktop.matches) return;

    document.querySelectorAll('.seerat-desktop-filters .price-range').forEach(function (range) {
      var slider = range.querySelector('.price-range__slider');
      var api = slider && slider.noUiSlider;
      if (!api || api.__seeratExactPriceStep) return;

      var limit = parseFloat(range.dataset.max);
      if (!Number.isFinite(limit) || limit <= 0) return;

      var minimum = parseFloat(range.dataset.minValue);
      var maximum = parseFloat(range.dataset.maxValue);
      minimum = Number.isFinite(minimum) ? Math.max(0, Math.min(minimum, limit)) : 0;
      maximum = Number.isFinite(maximum) ? Math.max(minimum, Math.min(maximum, limit)) : limit;

      // Native filtering remains in charge. A one-rupee step keeps amounts
      // such as 745 and 29995 consistent with the actual selected filter.
      api.updateOptions({ step: 1, start: [minimum, maximum] }, false);
      api.__seeratExactPriceStep = true;
    });
  }

  document.addEventListener('page:loaded', syncPriceRanges);
  document.addEventListener('collection:reloaded', syncPriceRanges);
  document.addEventListener('shopify:section:load', syncPriceRanges);
  desktop.addEventListener('change', syncPriceRanges);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncPriceRanges);
  } else {
    syncPriceRanges();
  }
})();
